export const getCurrentcompleteDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Ensures two-digit format
    const day = String(today.getDate()).padStart(2, '0'); // Ensures two-digit format
    // return `${year}-${month}-${day}`;
    return `${year}-${month}-${day}`;
};
